import React, {useEffect} from 'react';
import {Col, InputNumber, Row, Skeleton,message, Spin} from "antd";
import {Button} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import BackServer from "../../api/BackServer";
import RefreshIcon from '@mui/icons-material/Refresh';
const OneStock = (props) => {
    const [myitem, setMyItem] = React.useState(null);
    const [currValue, setCurrValue] = React.useState(0);
    const [nowWait, setnowWait] = React.useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    // alert(JSON.stringify(props))
    // console.log(props.datas.value);
    let stylex= {
        // background: '#0092ff',
        marginTop: '8px',
    };
    const info = () => {
        messageApi.info('Hello, Ant Design!');
    };
    function handleChangex(e) {
        // myitem.present=e.target.value
        // alert(e);
        setCurrValue(e);
    }
    const getStocksbyID = async () => {
        setnowWait(true)
        await BackServer.getStockFromMyBDNEW(props.datas,"-").then(u => {
            if (u!=undefined && u!=null && u!=undefined) {
                console.log(u.dta[0])
                // console.log("Sss")
                setCurrValue(u.dta[0].value.present)
                setMyItem(u.dta[0].value)
                setnowWait(false)
            }
        })
    }
    const handleOpenx = async () => {
        setnowWait(true)
        // const response = await axios.get(`${baseUrl_back}/goBananasBot/getStockFromMyBD?article=`+ article)
        await BackServer.addstock(myitem._id, currValue, "all").then(u => {
            if (u!=undefined && u!=null && u!=undefined) {
                messageApi.info('Изменено: ('+ myitem._id +") "+myitem.shortName+ " кол: "+ currValue);
                setnowWait(false)
            }
        })


        // alert(JSON.stringify(response.dta));
        // alert(response.dta)
        // setOpen()
    }
    // const SetStockSID = async () => {
    //      await BackServer.addstock(myitem._id, myitem.present, "all").then(u => {
    //         if (u!=undefined && u!=null && u!=undefined) {
    //             getStocksbyID()
    //         }
    //     })
    // }

    const response =
    useEffect(() => {
        getStocksbyID()
    }, [])
    if (myitem==null)
        return(
        <Row gutter={5}>
            <Col style={stylex} span={2}>
                <Skeleton.Button active={true} size={"small"}  block={true} />
                {/*<Button variant="contained" size="medium" block fullWidth>{myitem._id}</Button>*/}
            </Col>
            <Col style={stylex}  span={8}>
                <Skeleton.Button active={true} size={"small"}  block={true} />
                {/*<Button  variant="contained" size="medium" block fullWidth></Button>*/}
            </Col>
            <Col style={stylex} span={8}>
                <Skeleton.Button active={true} size={"small"}  block={true} />
                {/*<Button variant="contained" size="medium" block fullWidth></Button>*/}
            </Col>
            <Col style={stylex} span={2}>
                <Skeleton.Button active={true} size={"small"}  block={true} />

            </Col>
            <Col style={stylex} span={1}>
                <Skeleton.Button active={true} size={"small"}  block={true} />
                {/*<Button variant="contained" onClick={getStocksbyID} size="medium" block fullWidth><RefreshIcon/></Button>*/}
            </Col>
            <Col style={stylex} span={1}>
                <Skeleton.Button active={true} size={"small"}  block={true} />
                {/*<Button variant="contained" size="medium" block fullWidth><SendIcon/></Button>*/}
            </Col>
        </Row>
    )
    return (
        <>
        {contextHolder}
        <Row gutter={5}>
            <Col style={stylex} span={2}>
                <Button variant="contained" size="medium" block fullWidth>{myitem._id}</Button>
            </Col>
            <Col style={stylex}  span={8}>
                <Button  variant="contained" size="medium" block fullWidth>{myitem.shortName}</Button>
            </Col>
            <Col style={stylex} span={8}>
                <Button variant="contained" size="medium" block fullWidth>{myitem.Color}</Button>
            </Col>
            <Col style={stylex} span={2}>
                <InputNumber
                    style={{
                        width: '100%',
                    }}
                    // addonAfter={<Button variant="contained" size="medium" block fullWidth><SendIcon/></Button>}
                    value={currValue}
                    onChange={handleChangex}
                    // defaultValue=
                />

            </Col>
            <Col style={stylex} span={1}>
                {(nowWait)?(
                        <Button onClick={handleOpenx} variant="contained" size="medium" block fullWidth><Spin /></Button>

                    ):
                    (
                        <Button variant="contained" onClick={getStocksbyID} size="medium" block fullWidth><RefreshIcon/></Button>
                    )}

            </Col>
            <Col style={stylex} span={1}>
                {(nowWait)?(
                    <Button onClick={handleOpenx} variant="contained" size="medium" block fullWidth><Spin /></Button>

                ):
                    (
                        <Button onClick={handleOpenx} variant="contained" size="medium" block fullWidth><SendIcon/></Button>
                    )}

            </Col>
        </Row>
        </>
    );
};

export default OneStock;